// removed by extract-text-webpack-plugin
module.exports = {"sapcnqr-icon-button":"sapcnqr-icon-button-6f3b02","sapcnqr-icon-button--lg":"sapcnqr-icon-button--lg-a068bc","sapcnqr-icon-button--wide":"sapcnqr-icon-button--wide-31d3b7"};